import React from 'react';
import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

const FieldGroupStyled = styled.div`
  margin-top: ${gridSize()}px;
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-top, opacity, transform;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;

  /* Offset @atlaskit/form/Field margin-top */
  &:first-of-type {
    margin-top: ${-gridSize()}px;
  }

  &.hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    overflow: hidden;
  }
`;

export default function FieldGroup(props: {
  isHidden?: boolean;
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <FieldGroupStyled
      {...props}
      className={`${props.className ? props.className : ''} ${props.isHidden ? 'hidden' : ''}`}
    />
  );
}
